export default {
  recommendedBoards: [],
  recommendedBoardSections: [],
  idOfQuestionBySlugAndIndex: {},
  listPerformance: {},
  examResults: {},
};
